// @flow
import {createSelector} from "reselect";
import type {State} from "../../Store";
import {CSSDirection} from "./utils";

const appSelector = (state: State) => state.app;

const getAlert = createSelector(
    appSelector,
    (app) => {
        return app.alert;
    }
);

const getRiderLocation = createSelector(
    appSelector,
    (app) => {
        return app.riderLocation;
    }
);
const getRiderLocationLat = createSelector(
    getRiderLocation,
    (riderLocation) => {
        return riderLocation && riderLocation.lat;
    }
);
const getRiderLocationLng = createSelector(
    getRiderLocation,
    (riderLocation) => {
        return riderLocation && riderLocation.lng;
    }
);
const getRiderLocationBearing = createSelector(
    getRiderLocation,
    (riderLocation) => {
        return riderLocation && riderLocation.bearing;
    }
);

const isTechnicalIssue = createSelector(
    appSelector,
    (app) => {
        return !!(app.technicalIssue);
    }
);

const getCSSDirection = createSelector(
    appSelector,
    (app) => {
        return app.direction || CSSDirection.ltr;
    }
);

export default {
    appSelector,
    getAlert,
    getRiderLocation,
    getRiderLocationLat,
    getRiderLocationLng,
    getRiderLocationBearing,
    isTechnicalIssue,
    getCSSDirection,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/App/selectors.js